const buttons = (editor,button) => {
  return editor.ui.registry.getAll().buttons[button] ?? null;
}

const buttonAction = (editor, button) => {
  const actionButton = buttons(editor, button)
  if (actionButton) { actionButton.onAction(); }
}

export const executeButtonAction = (editor, button) => {
  buttonAction(editor, button);
}